// removed by extract-text-webpack-plugin
module.exports = {"crossword":"Crossword__crossword___36YuG","title":"Crossword__title___d5ODR","cells":"Crossword__cells___2sfX1","container":"Crossword__container___2QFXN","keyboard":"Crossword__keyboard___2iz0Q","pirate":"Crossword__pirate___3U_mf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Crossword/Crossword.css
// module id = 822
// module chunks = 0